import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { head } from 'lodash';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { AccountPaymentTable } from 'web-ui-components/lib/finance/accounts';
import withContent from '../../../containers/withContent';
import paymentDetailsContent, { contentPropTypes } from './ChapsPaymentDetails.content';
import { verificationPropTypes } from '../../../states/payments/propTypes';
import {
	getBatchSinglePaymentInfo,
	getChapsBatchPaymentDetails,
	getChapsFileUploadData,
} from '../../../utils/paymentsUtils';
import PaymentInfoTable from '../PaymentInfoTable';
import { fxChargesProptypes } from '../../../states/rates/propTypes';
import withFxCharge from '../../../containers/withFxCharge';

const ChapsBatchPaymentDetails = ({
	content,
	payment: { payments, ...verificationInfo },
	fxCharges,
	newPaymentDates: { newSubmissionDate } = {},
}) => {
	const { title } = content;
	const firstPayment = head(payments);
	const paymentDetails = getChapsBatchPaymentDetails(content, verificationInfo, {
		...firstPayment,
		length: payments.length,
		submission_date: newSubmissionDate || firstPayment.submission_date,
	});
	const headerFileUploadChaps = [
		{ type: 'account', label: content.fromLabel },
		{ type: 'account', label: content.toLabel },
		{ type: 'currency', label: content.amountLabel },
		{ type: 'iban', label: content.refLabel },
		{ type: 'currency', label: content.feesLabel },
	];
	const rows = getChapsFileUploadData(payments, fxCharges[firstPayment.id]).flat();

	const paymentInformationTable = () => {
		if (firstPayment.file_upload) {
			return (
				<div className="u-margin-y-2">
					<AccountPaymentTable headerData={headerFileUploadChaps} tableData={rows} />
				</div>
			);
		}
		return payments.map((chapsPayment) => {
			const batchPaymentDetails = getBatchSinglePaymentInfo(content, chapsPayment, fxCharges[firstPayment.id]);
			return (
				<div key={chapsPayment.id} className="u-margin-y-1">
					<PaymentInfoTable paymentDetails={batchPaymentDetails} />
				</div>
			);
		});
	};
	return (
		<div>
			<SectionHeading>{title}</SectionHeading>
			<div className="u-margin-bottom-2">
				<PaymentInfoTable paymentDetails={paymentDetails} />
				{paymentInformationTable()}
			</div>
		</div>
	);
};

ChapsBatchPaymentDetails.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payment: PropTypes.shape(verificationPropTypes),
	fxCharges: PropTypes.shape(fxChargesProptypes),
	newPaymentDates: PropTypes.shape({
		newSubmissionDate: PropTypes.string,
	}),
};

export default compose(withContent({ content: paymentDetailsContent }), withFxCharge)(ChapsBatchPaymentDetails);
